import {
  startRegistration as libStartRegistration,
  startAuthentication as libStartAuthentication
} from "@simplewebauthn/browser";

// True when the browser exposes the WebAuthn API at all. Callers must check
// this before rendering any passkey control -- a button that cannot work is
// worse than no button.
export function isPasskeySupported() {
  return typeof window !== "undefined" && !!window.PublicKeyCredential;
}

// When the user dismisses the browser's passkey prompt, the underlying
// library throws (or wraps into) an error named "NotAllowedError". We
// normalise that into a plain Error carrying `cancelled: true` so callers can
// tell "user cancelled" apart from "ceremony actually failed" and stay silent
// on a cancel instead of showing a scary error.
function normaliseError(error) {
  if (error && error.name === "NotAllowedError") {
    const cancelledError = new Error(error.message || "Passkey ceremony was cancelled");
    cancelledError.cancelled = true;
    cancelledError.cause = error;
    return cancelledError;
  }
  return error;
}

// Thin wrapper over @simplewebauthn/browser's startRegistration so nothing
// else in the app imports the library directly.
export async function startRegistration(options) {
  try {
    return await libStartRegistration(options);
  } catch (error) {
    throw normaliseError(error);
  }
}

// Thin wrapper over @simplewebauthn/browser's startAuthentication so nothing
// else in the app imports the library directly.
export async function startAuthentication(options) {
  try {
    return await libStartAuthentication(options);
  } catch (error) {
    throw normaliseError(error);
  }
}
